export * from '../wizard/review-your-contract/ReviewYourContract.texts';
export const jumpToLabels = {
  contractDetails: 'Contract Details',
  documents: 'Contract Documents',
  supplierDetails: 'Supplier Details',
  uploadDocument: 'Upload Files',
  setReminder: 'Set a Reminder',
} as const;
